import React from 'react';
import Link from 'next/link';
import styles from './TanyaWidget.module.scss';

const TANYA_WIDGET_TITLE = 'Tanya Lifepal';
const TANYA_WIDGET_SUBTITLE = 'Untuk Pertanyaan Keuanganmu';

interface TanyaWidgetProps {
  author: string;
  title: string;
  content: string;
  url: string;
}

const TanyaWidget = (props: TanyaWidgetProps) => {
  const { author, title, content, url } = props;
  return (
    <div className={styles['tanya-widget__wrapper']}>
      <div className={styles['tanya-widget__head']}>
        <span className={styles['tanya-widget__head--title']}>{TANYA_WIDGET_TITLE}</span>
        <span
          className={styles['tanya-widget__head--subtitle']}
        >{` - ${TANYA_WIDGET_SUBTITLE}`}</span>
      </div>
      <div className={styles['tanya-widget__body']}>
        <span className={styles['tanya-widget__body--title']}>{title}</span>
        <span className={styles['tanya-widget__body--content']}>{content}</span>
        <span className={styles['tanya-widget__body--author']}>{`Dijawab : ${author}`}</span>
      </div>
      <div className={styles['tanya-widget__footer']}>
        <Link href={url}>
          <a target="_blank" title="Baca Selengkapnya">
            Baca Selengkapnya
          </a>
        </Link>
      </div>
    </div>
  );
};

export default TanyaWidget;
